import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';

import { History } from "../dto/History";

function Expectation(id, title) {
    this.id = id;
    this.title = title;
}


function Entry(raw) {
    this.raw = raw;
}
Entry.prototype.getQuestionId = function () {
    if (this.raw?.entry) {
        return this.raw.entry?.id;
    }
    return "";
};
Entry.prototype.getQuestionTitle = function () {
    if (this.raw?.entry) {
        return this.raw.entry?.title;
    }
    return "";
};
Entry.prototype.getQuestionAllNumber = function () {
    if (this.raw?.entry) {
        return this.raw.entry?.allstep;
    }
    return "";
};
Entry.prototype.getQuestionNumber = function () {
    if (this.raw?.entry) {
        return this.raw.entry?.step;
    }
    return "";
};
Entry.prototype.getQuestionDescription = function () {
    return "";
};
Entry.prototype.getExpectations = function () {
    let es = [];
    for (let i in this.raw?.entry?.expectations) {
        let e = this.raw?.entry?.expectations[i];
        es.push(
            new Expectation(
                e.id,
                e.title
            )
        );
    }

    return es;
}
Entry.prototype.getHistory = function () {
    let hs = [];

    for (let i in this.raw?.histories) {
        hs.push(new History(this.raw?.histories[i]))
    }

    return hs;
};


function ExpectationPage(callback = function () { }) {
    Page.call(this, "Expectation", "質疑応答");
    this.interviewId = "";
    this.entry = null;
    this.selecteds = [];
    this.histories = [];
    this.callback = callback;
    this.isReset = false;
    this.isProgress = true;
}
tacklebox.design.extend(ExpectationPage, Page);
ExpectationPage.prototype.isSelected = function () {
    return this.selecteds.length > 0;
};
ExpectationPage.prototype.entry = function () {

};
ExpectationPage.prototype.reset = function () {
    this.isReset = true;
    this.selecteds = [];
};
ExpectationPage.prototype.select = function (expectation_id) {
    this.isReset = false;
    for (let i = 0; i < this.selecteds.length; i++) {
        let sid = this.selecteds[i];
        if (sid == expectation_id) {
            this.selecteds.splice(i, 1);
            return;
        }
    }
    this.selecteds.push(expectation_id);
};

ExpectationPage.prototype._onInitialize = function () {
    const self = this;
    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/ask", {
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then((response) => response.json())
        .then((json) => {
            self.entry = new Entry(json.data);
            if (self.entry.getExpectations()?.length == 0) {
                if (self.callback) {
                    self.callback("fix");
                    return;
                }
            }
            this.isProgress = false;
        })
        .catch((error) => {
            tacklebox.e(error);
            this.isProgress = false;
        });
};
ExpectationPage.prototype.regist = function () {
    if (!this.isSelected()) {
        return;
    }
    const self = this;

    let ignores = [];
    if (this.entry) {
        let exs = this.entry.getExpectations();
        for (let i in exs) {
            let isHit = false;
            for (let j in this.selecteds) {
                let sid = this.selecteds[j];
                if (sid == exs[i].id) {
                    isHit = true;
                    break;
                }
            }
            if (!isHit) {
                ignores.push(exs[i].id);
            }
        }
    }
    let rbody = {
        "id": this.entry.getQuestionId(),
        "requires": this.selecteds,
        "ignores": ignores
    }

    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/entry/similar", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            if (json) {
                //
            }
            fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + self.interviewId + "/ask", {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json) {
                        //
                    }
                    self.selecteds = [];
                    self.entry = new Entry(json.data);
                    if (self.entry.getExpectations()?.length == 0) {
                        if (self.callback) {
                            self.callback("fix");
                        }
                    }
                })
                .catch((error) => {
                    tacklebox.e(error)
                });

        })
        .catch((error) => {
            tacklebox.e(error)

        });
};


ExpectationPage.prototype.fix = function (callback = (expectations_cnt) => { tacklebox.d(expectations_cnt) }) {
    let rbody = {
        "session": "x"
    };

    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/start", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            if (json?.data) {
                if (callback) {
                    callback(1);
                }
            }
            if (callback) {
                // callback(-1);
                callback(1);
            }
        })
        .catch((error) => {
            tacklebox.e(error)
            if (callback) {
                callback(-1);
            }
        });
};
ExpectationPage.prototype.loadEntry = function () {
    const self = this;
    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + self.interviewId + "/ask", {
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then((response) => response.json())
        .then((json) => {
            self.selecteds = [];
            self.entry = new Entry(json.data);
        })
        .catch((error) => {
            tacklebox.e(error)
        });


};
ExpectationPage.prototype.cencel = function () {
    const self = this;
    if (this.entry) {
        let hs = this.entry.getHistory();
        if (hs.length > 1) {
            let trg = hs[hs.length - 1];
            if (trg.getPhase() == 'entry') {
                fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/history/" + trg.getId(), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then((response) => response.json())
                    .then((json) => {
                        if (json) {
                            //
                        }
                        self.loadEntry();
                    })
                    .catch((error) => {
                        tacklebox.e(error)
                    });

            }

        }
    }
};
export { ExpectationPage }
